import {EnvironmentAdmin} from 'compob2b-libs';

/**
 * Конфигурация тестового сервера, он же Staging
 */
class EnvironmentAdminTest extends EnvironmentAdmin {
  production = true;
  serviceWorkers = true;
  serverPicturesPath = 'https://formic.compo-soft.ru/pictures';
  serverDocumentsPath = 'https://formic.compo-soft.ru/documents';
  serverApi =  'https://formic.compo-soft.ru/api/v1';
  serverUrl =  'https://formic.compo-soft.ru';
  impersonate: false;
  accessRolesCatalog = true;
  enableWorkflowButton = true;
  showDiscountPanel = true;
  featureGroupPermissions = true;
  publicShowcase = true;
  commonFeatureGroup = true;
}

export const environment = new EnvironmentAdminTest();
